import zxcvbn from 'zxcvbn';
import {compare, bignumber} from 'mathjs';
import numeral from 'numeral';
import jQuery from 'jquery';

let math = {};
math.bignumber = bignumber;
math.compare = compare;

jQuery(document).on("click", ".th-error-box.active", function() {
    jQuery(this).trigger('th-validator-error.click');
});

jQuery(document).on('th-validator-error.click', ".th-error-box.active", function() {
    jQuery(this).removeClass("active"); 
    jQuery(this).parent().find("input").focus();
});

/** Singleton validator class
 * 
 */
class TH_Validator {
    constructor() {
        this.rules = {
            'placeholder':  this.validate_placeholder,
            'zxcvbn': this.validate_zxcvbn,
            'required': this.validate_required,
            'exactlength': this.validate_exactlength,
            'minlength': this.validate_minlength,
            'minval': this.validate_minval,
            'maxval': this.validate_maxval,
            'email': this.validate_email,
            'url': this.validate_url,
            'phonenumber': this.validate_phonenumber,
            'equals': this.validate_equals,
            '!equals': this.validate_notequals,
            'number': this.validate_number
        }
    }

    /** Validate a form element
     * 
     * @param jQuery (the elem to validate)
     * 
     */
    validate_elem(elem) {
        let data = jQuery(elem).data('validate'),
            valid_elem = true;
        
        for (let i=0; i < data.length; i++) {
            if (!this.validate_rule(elem, data[i])) {
                valid_elem = false;
                this.activate_error(elem, data[i]);
                break;
            }
        }

        if (jQuery(elem).hasClass('skip-js-validate')) valid_elem = true;
        if (valid_elem === true) this.deactivate_error(elem);

        return valid_elem;
    }

    /** Deactivate an error box on a validatable elem
     * 
     * @param jQuery elem (the elem to deactivate the box on)
     * 
     */
    deactivate_error(elem) {
        jQuery(elem).parents(".validate-container").find(".th-error-box").removeClass('active');
    }

    /** Activate a specific error on an elem
     * 
     * @param jQuery elem (the elem to activate the error on)
     * @param object rule (the error rule to activate)
     * 
     */
    activate_error(elem, rule) {
        let ErrorBox=jQuery(elem).parents(".validate-container").find(".th-error-box");


        ErrorBox.addClass('active');
        ErrorBox.find(".error-message").html(rule.error);
    }

    /** Validate a specific rule on a specific elem
     * 
     */
    validate_rule(elem, rule) {
        let split_rule_type = rule.type.split("->");

        if (typeof this.rules[split_rule_type[0]] != 'undefined') return this.rules[split_rule_type[0]].apply(this, [elem, split_rule_type, rule]);

    }

    /** Validate rule - placeholder
     * 
     */
    validate_placeholder(elem, rule, splitRule) {
        return true;
    }

    
    /** Validate rule -- zxcvbn
     * 
     * @UsableOn: input
     * @Description: validates if the content of the input passes the zxcvbn score
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_zxcvbn(elem, validationSpec, originalRule) {
        let validateData,
            strength;

        if (typeof validationSpec == 'undefined') {
            console.error("validate_zxcvbn:: validation excepts a strength as the second parameter of the validation spec variable", elem, validationSpec, originalRule);
            return false;
        }
 
        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_zxcvbn:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;
 
        strength = zxcvbn(validateData);
         
        if (strength.score >= validationSpec[1]) return true;
        else return false;
     }

    /** Validate rule -- required
     * 
     * @UsableOn: input, select, textarea
     * @Description: validates if the input element is not empty
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_required(elem, validationSpec, originalRule) {
        let validateData;

        if (elem instanceof jQuery) validateData = elem.val();
        else validateData = elem;

        if (validateData !== '' && validateData !== null) return true;
        else return false;
    }

    /** Validate rule -- exactlength
     * 
     * @UsableOn: input
     * @Description: validates if the inputed text has exactly X length
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_exactlength(elem, validationSpec, originalRule) {
        let validateData,
            lengthNeeded;
            
        if (typeof validationSpec == 'undefined') {
            console.error("validate_exactlength:: validation excepts a length as the second parameter of the validation spec variable", elem, validationSpec, originalRule);
            return false;
        }

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_exactlength:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        lengthNeeded = validationSpec[1];
        if (validateData.length != lengthNeeded) return false;
        else return true;
    }

    /** Validate rule -- minlength
     * 
     * @UsableOn: input
     * @Description: validates if the inputed text has at least X length
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_minlength(elem, validationSpec, originalRule) {
        let validateData,
            lengthNeeded;
            
        if (typeof validationSpec == 'undefined') {
            console.error("validate_minlength:: validation excepts a length as the second parameter of the validation spec variable", elem, validationSpec, originalRule);
            return false;
        }

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_minlength:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        lengthNeeded = validationSpec[1];
        if (validateData.length < lengthNeeded) return false;
        else return true;
    }

    /** Validate rule -- minval
     * 
     * @UsableOn: input
     * @Description: validates if the content of the input is numeric, and has at least X value
     * 
     */
    validate_minval(elem, validationSpec, originalRule) {
        let validateData,
            minval;

        if (typeof validationSpec == 'undefined') {
            console.error("validate_minval:: validation excepts a length as the second parameter of the validation spec variable", elem, validationSpec, originalRule);
            return false;
        }

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_minval:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        minval = validationSpec[1];

        if (this.validate_number(elem, validationSpec, originalRule)) {
            if (validateData === null || validateData == '') return false;
            else if (math.compare(math.bignumber(minval), math.bignumber(validateData)) == 1) return false;
            else return true;
        } else return false;
    }

    /** Validate rule -- maxval
     * 
     * @UsableOn: input
     * @Description: validates if the content of the input is numeric, and has at most X value
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     *  
     */
    validate_maxval(elem, validationSpec, originalRule) {
        let validateData,
            maxval;

        if (typeof validationSpec == 'undefined') {
            console.error("validate_maxval:: validation excepts a length as the second parameter of the validation spec variable", elem, validationSpec, originalRule);
            return false;
        }

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_maxval:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        maxval = validationSpec[1];

        if (this.validate_number(elem, validationSpec, originalRule)) {
            if (validateData === null || validateData == '') return false;
            else if (math.compare(math.bignumber(maxval), math.bignumber(validateData)) == -1) return false;
            else return true;
        } else return false;
    }

    /** Validate rule -- email
     * 
     * @UsableOn: input
     * @Description: validates if the content of the input is a valid e-mail address
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_email(elem, validationSpec, originalRule) {
        let validator,
            validateData;

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_email:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        if (validateData == '') return true;
        validator=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (validator.test(validateData)) return true;
        else return false;

    }

    /** Validate rule -- phonenumber
     * 
     * @UsableOn: input initialized with intltelinput
     * @Description: validates if the content of the input is a valid phone number
     * 
     * @param jQuery        elem              (a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_phonenumber(elem, validationSpec, originalRule) {
        let validInput = false;

        if (elem instanceof jQuery) {
            if (elem.is('input')) {
                // TODO: test if it is indeed a phone number input
                validInput = true;
            }
        }

        if (!validInput) {
            console.error("validate_phonenumber:: does not work on the type of element you provided", elem, validationSpec, originalRule);
            return false;
        }

        if (elem.val() == '') return true;
        else return elem.data('intltelinput').isValidNumber();
    }

    /** Validator rule -- url
     * 
     * @UsableOn: input
     * @Description: validates if the content of the input is a valid url
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     * 
     */
    validate_url(elem, validationSpec, originalRule) {
        let validator,
            validateData;

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_url:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        if (validateData == '') return true;
        if (validateData.substring(0, 7) != "http://" && validateData.substring(0, 8) != "https://" && validateData.substring(0, 6) != "ftp://") validateData = "http://" + validateData;
        if (validateData.substr(validateData.length - 1) != "/") validateData+="/";
        
        validator = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i;
        if (validator.test(validateData)) {
            if (elem instanceof jQuery) elem.val(validateData);
            return true;
        } else return false;
    }

    /** Validator rule -- equals
     * 
     * @UsableOn: input, select
     * @Description: validates if the content of the validated elem, equals with the content of another validated elem
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_equals(elem, validationSpec, originalRule) {
        let validationData;

        if (typeof validationSpec == 'undefined') {
            console.error("validate_equals:: validation excepts a length as the second parameter of the validation spec variable", elem, validationSpec, originalRule);
            return false;
        }

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_equals:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        if (validateData == jQuery("#" + validationSpec[1]).val()) return true;
        else return false;
    }

    /** Validator rule -- !equals
     * 
     * @UsableOn: input, select
     * @Description: validates if the content of the validated elem, is not equal to the content of another elem
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     * 
     */
    validate_notequals(elem, validationSpec, originalRule) {
        return !this.validate_equals(elem, validationSpec, originalRule);
    }

    /** Validator rule -- number
     * 
     * @UsableOn: input
     * @Description: validates if the content of the input is numeric
     * 
     * @param string|jQuery elem              (either a string, or a jquery instance to use)
     * @param array         validationSpec    (specifications for the validations, by default it will be an empty array)
     * @param string        originalRule      (original rule, used by the Form js, to provide the original rule provided on the backend, by default it is empty)
     *  
     */
    validate_number(elem, validationSpec, originalRule) {
        let validationData;

        if (elem instanceof jQuery) {
            if (elem.is('input')) validateData = elem.val();
            else {
                console.error("validate_number:: does not work on the type of element you provided", elem, validationSpec, originalRule);
                return false;
            }
        } else validateData = elem;

        if (validateData == '' || validateData === null) return true;
        if (validateData.charAt(0) == '-') validateData = validateData.substr(1);
        return numeral.validate(validateData);
    }
}

export default TH_Validator;